
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "{{#showAccountSuggestion}}\n  <div class=\"info mx-auto mb-5\" id=\"suggest-account\">\n      {{#unsafeTranslate}}Why do I need to create this account? <a %(escapedSuggestionAttrs)s>Find out here</a>{{/unsafeTranslate}}\n      <span class=\"dismiss\" tabindex=\"-1\">&#10005;</span>\n  </div>\n{{/showAccountSuggestion}}\n"
      return mustache.render(src, view, partials);
    };
  